import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SidenavItem } from './sidenav-item/sidenav-item.model';
import { Observable } from 'rxjs';
import * as fromRoot from '../../reducers/index';
import { Store } from '@ngrx/store';
import { CommonService } from '../../services/api/common.service';
import { DataService } from '../../services/api/data-service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProfileService } from '../../services/api/profile.service';
import { Profile } from '../../pages/settings/profile/profile.model';
import { VendorService } from '../../services/api/vendor.service';
import { Parties } from '../../pages/user-management/vendor/parties.model';
import { ColdStore } from '../../pages/user-management/cold-store/cold-store.model';
import { ColdStoreService } from '../../services/api/cold-store.service';
import { ProfileTypeService } from '../../services/api/profile-type.service';
import { ProfileType } from '../../pages/settings/profile-type/profile-type.model';
import { Commodity } from '../../pages/settings/commodity/commodity.model';
import { CommodityService } from '../../services/api/commodity.service';
import { Region } from '../../pages/user-management/region/region.model';
import { RegionService } from '../../services/api/region.service';
import { Site } from '../../pages/user-management/site/site.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderComponent } from '../loader/loader.component';

@Component({
    selector: 'vr-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, OnDestroy {
    previousUrl: string;
    coldList: ColdStore[];
    profile: Profile[];
    profileType: ProfileType[];
    commodityDD: Commodity[];
    parties: Parties[];
    sites: Site[];
    tap = null;
    cluster = null;
    village = null;
    farmer = null;
    fieldstaff = null;
    pick = null;
    barntype = null;
    furnace = null;
    barnsize = null;
    energyefficient = null;
    connectivity: any;
    region = null;
    form: FormGroup;
    barnId: any;
    farmerId: any;
    fieldStaffId: any;
    tapId: any;
    regionId: any;
    clusterId: any;
    villageId: any;
    pickNumber: any;
    barnid = null;
    barnType: any;
    furnaceType: any;
    barnSize: any;
    insulationType: any;
    open = false;
    openn = false;
    opennn = false;
    commodity = null;
    site = null;
    profileT = null;
    regions: Region[];
    levelid = null;
    csStatusId = null;
    partyid = null;
    profileid = null;
    regionid = null;
    userid = null;
    location = null;
    siteid = null;
    profileTypeId = null;
    commodityid = null;
    connectivityid = null;
    myControl = new FormControl();
    farmerCtrl = new FormControl();
    @Input('layout') layout: string; // Layout
    @Input('collapsed') collapsed: boolean;
    @Output('toggledSidenavCollapse') toggledSidenavCollapse = new EventEmitter();
    farmers: string[] = [];

    regionArray = [];
    tapArray = [];
    clusterArray = [];
    villageArray = [];
    locations = [];

    sidenavItems$: Observable<SidenavItem[]>;
    currentlyOpen$: Observable<SidenavItem[]>;
    dialogRef: MatDialogRef<LoaderComponent>;

    constructor(
        private dialog: MatDialog,
        private store: Store<fromRoot.State>, private data: DataService, private commonService: CommonService, private fb: FormBuilder, private cdr: ChangeDetectorRef, private profileService: ProfileService,
        private vendorService: VendorService, private coldStoreService: ColdStoreService, private profileTypeService: ProfileTypeService, private commodityService: CommodityService, private regionService: RegionService) {
        /*
                this.filteredFarmers = this.myControl.valueChanges.pipe(
                    startWith(null),
                    map((fruit: string | null) => fruit ? this._filter(fruit) : this.farmersList.slice()));*/
    }

    ngOnInit() {
        this.callDDListApis();
        this.sidenavItems$ = this.store.select(fromRoot.getSidenavItems);
        this.currentlyOpen$ = this.store.select(fromRoot.getSidenavCurrentlyOpen);
        this.data.currentValue.subscribe(message => this.coldList = message);
        this.form = this.fb.group({
            partyid: [this.partyid || ''],
            location: [this.location || ''],
            profileid: [this.profileid || ''],
        });
    }

    private callDDListApis(){
        
        this.getProfileDD();
        this.getAllPartiesDD(0, 10000);
        this.getLocationDD();
        this.getProfileTypeDD();
        this.getCommodityDD();
        this.getRegionDD();
    }

    getProfileDD() {
        this.profileService.getProfileDD().subscribe(jsonResp => {
            this.profile = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }

    getProfileTypeDD() {
        this.profileTypeService.getProfileTypeDD().subscribe(jsonResp => {
            this.profileType = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }

    getCommodityDD() {
        this.commodityService.getCommodityDD().subscribe(jsonResp => {
            this.commodityDD = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }
    getRegionDD() {
        this.regionService.getAllRegionDD().subscribe(jsonResp => {
            this.regions = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }
    getSitesByRegion() {
        this.regionService.getSitesByRegion(this.regionid).subscribe(jsonResp => {
            this.sites = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }

    getAllPartiesDD(pageNumber: any, limit: any) {
        this.vendorService.getAllPartiesDD(pageNumber, limit).subscribe(jsonResp => {
            this.parties = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }

    getLocationDD() {
        this.coldStoreService.getLocationDD().subscribe(jsonResp => {
            this.locations = jsonResp.data;
            this.cdr.detectChanges();
        },
            err => {
                console.log(JSON.stringify(err));
            });
    }

    getColdStoreBasedOnFilter() {
        const coldStore = this.form.value;
        const coldStoreObj: ColdStore = new ColdStore();
        coldStoreObj.partyId = this.partyid;
        coldStoreObj.regionId = this.regionid;
        coldStoreObj.siteId = this.siteid;
        coldStoreObj.profileTypeId = this.profileTypeId;
        coldStoreObj.commodityId = this.commodityid;
        coldStoreObj.online = this.connectivityid;
        coldStoreObj.esclationLevelId = this.levelid;
        coldStoreObj.csStatusId = this.csStatusId;
        coldStoreObj.profileId = this.profileid;
        this.coldList = [];
        this.dialogRef = this.dialog.open(LoaderComponent, {
            disableClose: true
        });
        this.coldStoreService.getColdStoreBasedOnFilter(coldStoreObj, 0, 30000).subscribe(jsonResp => {
            this.coldList = jsonResp.data;
            this.cdr.detectChanges();
            this.data.changeValue(this.coldList);
        },
            err => {
                console.log(JSON.stringify(err));
            }, () => {
                this.dialog.closeAll();
            });

        this._getCount();
    }

    private _getCount() {
        const coldStoreObj: ColdStore = new ColdStore();
        coldStoreObj.partyId = this.partyid;
        coldStoreObj.regionId = this.regionid;
        coldStoreObj.siteId = this.siteid;
        coldStoreObj.profileTypeId = this.profileTypeId;
        coldStoreObj.commodityId = this.commodityid;
        coldStoreObj.online = this.connectivityid;
        coldStoreObj.esclationLevelId = this.levelid;
        coldStoreObj.csStatusId = this.csStatusId;
        coldStoreObj.profileId = this.profileid;
        this.commonService.getCountWithFilter(coldStoreObj).subscribe(res => {            
            if(res && res['data'] && res['data'].length){
                let counts = res['data'][0];
                if(!counts['totalCount']){counts['totalCount'] = 0}
                if(!counts['totalOperators']){counts['totalOperators'] = 0}
                if(!counts['totalOnline']){counts['totalOnline'] = 0}
                this.data.changeCount(counts);
            }
        }, err => {
            let counts = {
                totalCount: 0,
                totalOperators: 0,
                totalOnline: 0
            }                
            this.data.changeCount(counts);
        });
    }

    toggleSidenavCollapse() {
        this.toggledSidenavCollapse.emit();
    }

    openMe() {
        this.open = !this.open;
    }

    openPick() {
        this.openn = !this.openn;
    }

    openNamed() {
        this.opennn = !this.opennn;
    }

    changeMenu(event, menu) {
        const classes = document.getElementsByClassName('mymenu');
        for (let i = 0; i < classes.length; i++) {
            classes[i].classList.remove('active');
        }

        event.currentTarget.classList.add('active');

        if (menu === 'menu') {

            const classes1 = document.getElementsByClassName('mymenu1');

            for (let i = 0; i < classes1.length; i++) {
                classes1[i].classList.add('activme');
            }
            const classes2 = document.getElementsByClassName('mymenu2');
            for (let i = 0; i < classes1.length; i++) {
                classes2[i].classList.remove('activme');
            }

        } else {
            const classes1 = document.getElementsByClassName('mymenu1');

            for (let i = 0; i < classes1.length; i++) {
                classes1[i].classList.remove('activme');
            }
            const classes2 = document.getElementsByClassName('mymenu2');
            for (let i = 0; i < classes1.length; i++) {
                classes2[i].classList.add('activme');
            }
            this.reset();
            this.callDDListApis();
        }
    }

    reset() {
        this.partyid = null;
        this.profileid = null;
        this.regionid = null;
        this.siteid = null;
        this.profileTypeId = null;
        this.commodityid = null;
        this.connectivityid = null;
        this.levelid = null;
        this.csStatusId = null;
        this.getColdStoreBasedOnFilter();
    }

    ngOnDestroy() {
    }
}
